<template>
  <div>
    <b-form-select :options="optionsPendencyPriority" v-model="modelComp">
    </b-form-select>
  </div>
</template>

<script>
export default {
  name: "PendencyPriorityDropdown",
  components: {},
  props: {
    model: {
      type: Number,
      default: 2,
    },
    showZero: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {};
  },
  computed: {
    modelComp: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", parseInt(value));
      },
    },
    optionsPendencyPriority() {
      if (this.showZero) {
        return [
          { value: 0, text: "" },
          { value: 1, text: "Alta" },
          { value: 2, text: "Média" },
          { value: 3, text: "Baixa" },
        ];
      }
      return [
        { value: 1, text: "Alta" },
        { value: 2, text: "Média" },
        { value: 3, text: "Baixa" },
      ];
    },
  },
  methods: {},
};
</script>
